export default __webpack_public_path__ + "a32941d48b6c170705ed37f746c96603.svg";